import React from 'react'
import { graphql } from 'gatsby'

import * as styles from './slice.module.scss'

import Ctas from '@/components/blocks-library/cta/ctas'
import Image from '@/components/image/image'
import StructuredTextDefault from '@/components/structured-text/structured-text-default'
import TextElement from '@/components/text-element/text-element'

export const Slice = (props) => {
  const { title, subtitle, items } = props
  if (!title && !subtitle && items.length === 0) {
    return <></>
  }
  return (
    <div className="container">
      <div className="row">
        <TextElement type="h2" text={title} />
        <TextElement type="h3" text={subtitle} />
      </div>
      <div className="row justify-content-center mt-2 mt-lg-4">
        {items &&
          (items.length === 1
            ? items.map((item, index) => (
                <div className="col-12 mb-4" key={`${item.title} ${index}`}>
                  <SliceItem data={item} isFull />
                </div>
              ))
            : items.map((item, index) => (
                <div className="col-xxl-6 mb-4" key={`${item.title} ${index}`}>
                  <SliceItem data={item} isFull={false} />
                </div>
              )))}
      </div>
    </div>
  )
}
export default Slice

export const SliceItem = ({ data, isFull = false }) => {
  const { imageBig, image, title, preTitle, subtitle, content, ctas } = data
  return (
    <div className={`card ${styles.cardBg}`}>
      <div className="row g-0 flex">
        {image && (
          <div className="col-md-4 col-lg-5 col-xl-4">
            <div className={`card-info ${styles.cardColImage}`}>
              <div>
                <Image image={isFull ? imageBig : image} alt={title} />
              </div>
            </div>
          </div>
        )}

        <div className={image ? 'col-md-8 col-lg-7 col-xl-8' : 'col-12'}>
          <div className={styles.cardColContent}>
            <div className="card-body">
              <div className="card-inner-body">
                <TextElement
                  type="div"
                  text={preTitle}
                  className={`${styles.preTitle} mb-3`}
                />
                <TextElement type="h3" text={subtitle} />
                <TextElement type="h2" text={title} />
                <StructuredTextDefault content={content} />
                <div className={`pt-3 ${styles.links}`}>
                  <Ctas items={ctas} isBgDark />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  fragment ImageSliceItemDefault on DatoCmsFileField {
    __typename
    alt
    gatsbyImageData(
      width: 230
      height: 340
      placeholder: BLURRED
      imgixParams: { w: "230", h: "340", fit: "crop", crop: "focalpoint" }
    )
  }
  fragment ImageSliceItemDefaultFull on DatoCmsFileField {
    __typename
    alt
    gatsbyImageData(
      width: 862
      height: 680
      placeholder: BLURRED
      imgixParams: { w: "862", h: "680", fit: "crop", crop: "focalpoint" }
    )
  }

  fragment SliceItem on DatoCmsSliceItem {
    __typename
    preTitle
    title
    image {
      ...ImageSliceItemDefault
    }
    imageBig: image {
      ...ImageSliceItemDefaultFull
    }
    content {
      value
    }
    ctas {
      __typename
      ... on DatoCmsCta {
        ...Cta
      }
    }
  }

  fragment SectionSlice on DatoCmsSlice {
    __typename
    id
    navigationLabel
    title
    subtitle
    items {
      ...SliceItem
    }
  }
`
